import { render, staticRenderFns } from "./backStep.vue?vue&type=template&id=aa5a773e&scoped=true"
import script from "./backStep.vue?vue&type=script&lang=js"
export * from "./backStep.vue?vue&type=script&lang=js"
import style0 from "./backStep.vue?vue&type=style&index=0&id=aa5a773e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_rj3s3qgubxnefw7btmb34khrpq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5a773e",
  null
  
)

export default component.exports